import React, { useState } from 'react';

const TermsAndConditionsManager = () => {
  // Data storage for multiple languages
  const [content, setContent] = useState({
    en: "<h2>English Terms</h2><p>Please read these carefully...</p>",
    es: "<h2>Términos en Español</h2><p>Por favor lea esto atentamente...</p>",
    fr: "<h2>Conditions en Français</h2><p>Veuillez lire attentivement...</p>"
  });

  const [currentLang, setCurrentLang] = useState('en');
  const [isEditing, setIsEditing] = useState(false);

  // Handle saving the current state
  const handleSave = () => {
    setIsEditing(false);
    console.log("Saving to database:", content);
    // Add your API call here (e.g., axios.post('/api/terms', content))
  };

  return (
    <div className="max-w-5xl mx-auto p-6 bg-gray-50 min-h-screen">
      <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200">
        
        {/* Header Area */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8 border-b pb-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-800">Legal Management</h1>
            <p className="text-gray-500">Edit Terms and Conditions across languages</p>
          </div>

          <div className="flex items-center gap-3">
            <span className="text-sm font-medium text-gray-600">Language:</span>
            <select 
              value={currentLang}
              onChange={(e) => setCurrentLang(e.target.value)}
              className="border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-indigo-500 outline-none"
            >
              <option value="en">🇺🇸 English</option>
              <option value="es">🇪🇸 Spanish</option>
              <option value="fr">🇫🇷 French</option>
            </select>
          </div>
        </div>

        {/* Editor Area */}
        <div className="mb-6">
          {isEditing ? (
            <textarea
              value={content[currentLang]}
              onChange={(e) => setContent({ ...content, [currentLang]: e.target.value })}
              placeholder="Start typing your terms here..."
              className="w-full h-96 p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none resize-none font-mono text-sm"
            />
          ) : (
            <div className="prose prose-slate max-w-none min-h-[300px] p-6 bg-white border rounded-lg shadow-inner overflow-y-auto whitespace-pre-wrap">
              {content[currentLang]}
            </div>
          )}
        </div>

        {/* Actions */}
        <div className="flex justify-end gap-4">
          {!isEditing ? (
            <button 
              onClick={() => setIsEditing(true)}
              className="bg-indigo-600 text-white px-6 py-2 rounded-lg hover:bg-indigo-700 transition font-semibold"
            >
              Edit {currentLang.toUpperCase()} Version
            </button>
          ) : (
            <button 
              onClick={handleSave}
              className="bg-green-600 text-white px-8 py-2 rounded-lg hover:bg-green-700 transition font-semibold shadow-lg"
            >
              Save & Publish
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsManager;